import { type RequestToken } from '../../types';
import { type HandlerAppInfo } from '../../data/handlerApps';
import { useTranslation } from '../../i18n/i18n';
import EmbeddedLayout from '../../layouts/EmbeddedLayout';
import FlowFooter from '../../components/FlowFooter';
import AppPickerContent from '../shared/AppPickerContent';

type Props = {
  tokens: RequestToken[];
  handlerApps: Record<string, HandlerAppInfo>;
  recommendedHandlerAppUuids: string[];
  onSelect: (token: RequestToken) => void;
  onCancel: () => void;
};

export default function EmbeddedAppPickerPage({
  tokens,
  handlerApps,
  recommendedHandlerAppUuids,
  onSelect,
  onCancel,
}: Props) {
  const { t } = useTranslation();

  return (
    <EmbeddedLayout
      footer={
        <FlowFooter
          secondaryLabel={t('agentStart.cancel')}
          onSecondary={onCancel}
        />
      }
    >
      <div className="flex flex-1 flex-col items-center w-full min-h-0 mt-6">
        <AppPickerContent
          className="flex-1 min-h-0"
          tokens={tokens}
          handlerApps={handlerApps}
          recommendedHandlerAppUuids={recommendedHandlerAppUuids}
          onSelect={onSelect}
        />
      </div>
    </EmbeddedLayout>
  );
}
